import { Locale, type LocalizedString } from "../Locale.js";
import { Team } from "../Team.js";

export const teamNameMap: Record<Team, LocalizedString> = {
	[Team.DivokejTurnoff]: {
		[Locale.cs]: "Divokej Turnoff",
		[Locale.en]: "Divokej Turnoff",
	},
	[Team.PHOlomoc]: {
		[Locale.cs]: "PHOlomóc",
		[Locale.en]: "PHOlomóc",
	},
	[Team.PohoranstiVidlaci]: {
		[Locale.cs]: "Pohoranští vidláci",
		[Locale.en]: "Pohoransti vidlaci",
	},
	[Team.OcelovaSmecka]: {
		[Locale.cs]: "ocelOVA smečka",
		[Locale.en]: "ocelOVA smečka",
	},
	[Team.PraHaHa]: {
		[Locale.cs]: "PraHaHa",
		[Locale.en]: "PraHaHa",
	},
	[Team.Other]: {
		[Locale.cs]: "Jiný tým",
		[Locale.en]: "Other team",
	},
};
